import {
  Component,
  Input,
  OnInit
}                           from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyService }           from '../companies/company.service';
import { HaynesProService }         from './haynes-pro.service';
import { MessagesService }          from '../messages/messages.service';
import { QuoteModel }               from '../core/models/quote';

@Component({
  selector   : 'wor-haynes-pro-lookup-settings',
  template: require('./haynes-pro.lookup.settings.component.html')
})
export class HaynesProLookupSettingsComponent implements OnInit {
  @Input() settings : CompanyIntegrationsModel;

  title : string = this.haynesProService.title;

  quote : QuoteModel = {
    period           : null,
    total_quoted_cost: null
  };

  lookupRequests             : string;
  subscriptionLookupRequests : string;

  constructor (
    public  companyService  : CompanyService,
    private haynesProService: HaynesProService,
    private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.lookupRequests             = this.haynesProService.getLookupRequests();
    this.subscriptionLookupRequests = this.haynesProService.getSubscriptionLookupRequests();

    if ( !this.companyService.company.has_haynes_pro_lookup ) {
      this.haynesProService.getLookupQuote()
      .then(( quote : QuoteModel ) => {
        this.quote = quote;
      });
    }
  }

  activate () : void {
    this.haynesProService.activateLookups()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.haynesProService.lookupsTitle
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    });
  }

  deactivate () : void {
    this.haynesProService.deactivateLookups()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.REMOVED_INTEGRATION', {
        name: this.haynesProService.lookupsTitle
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    });
  }

  purchase () : void {
    this.haynesProService.purchaseLookups()
    .then(() => {
      this.router.stateService.reload();
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    });
  }

  save () : void {
    this.haynesProService.saveSubscriptionSettings(this.settings)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

      this.router.stateService.reload();
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    });
  }

}
